/**
 * v-model に対応する computed なプロパティを生成します.
 *
 * @param {string[]} keys 生成するキー名の配列
 * @param {function} getter getter関数
 * @param {function} setter setter関数
 */
export function models(keys, getter, setter) {
  return keys.reduce(
    (computed, key) =>
      Object.assign(computed, {
        [key]: {
          get() {
            return getter(this, key)
          },
          set(value) {
            return setter(this, key, value)
          },
        },
      }),
    {},
  )
}
